import Alpine from 'alpinejs';

window.Alpine = Alpine;

// import intersect from '@alpinejs/intersect'
// Alpine.plugin(intersect);

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


import collapse from '@alpinejs/collapse';

Alpine.plugin(collapse);

import 'keen-slider/keen-slider.min.css';
import KeenSlider from 'keen-slider';

window.KeenSlider = KeenSlider;

window.app = {
    init: function () {
        app.initEventListeners(document);
        app.methods.initOnhashChange(document);
        app.methods.initAnimations(document);
    },
    initEventListeners: function (context) {
        context.addEventListener('click', function (e) {
            const closeBtn = e.target.closest('.overlay-close');
            if (closeBtn) {
                const overlay = context.querySelector('.team-overlay');
                if (overlay) {
                    overlay.classList.add('hidden');
                    document.body.classList.remove('overflow-hidden');
                }

                // Remove the hash from the URL without reloading the page
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        });
    },
    listeners: {},
    methods: {

        initOnhashChange: function (context) {
            function handleHashChange() {
                const hash = window.location.hash;
                if (hash.startsWith('#team-')) {
                    const overlay = context.querySelector('.team-overlay');
                    if (overlay) {
                        document.body.classList.add('overflow-hidden');
                        overlay.classList.remove('hidden');
                    }
                }
            }

            // Run once immediately — this is for page load
            handleHashChange();

            // Listen for hash changes (from clicking links or JS)
            window.addEventListener('hashchange', handleHashChange);

            // Optional: handle instant link clicks
            context.addEventListener('click', function (e) {
                const target = e.target.closest('a[href^="#team-"]');
                if (target) {
                    // Wait for hash to update
                    setTimeout(handleHashChange, 0);
                }
            });
        },

        initAnimations: function (context) {
            /*
            gsap.from(context.querySelectorAll('.blockIntro > *'), {
                opacity: 0,
                y: 20,
                duration: 1,
                ease: 'power2.out',
            });
             */

            const titles = context.querySelectorAll('.intro-title');
            titles.forEach(title => {
                gsap.from(title, {
                    x: -1000,              // start 100px off to the left
                    opacity: 0,
                    duration: 1,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: title,
                        start: 'top 80%',    // when the top of the title hits 80% down the viewport
                        toggleActions: 'play none none none'
                    }
                });
            });

            const payoffs = context.querySelectorAll('.intro-payoff');
            payoffs.forEach(title => {
                gsap.from(title, {
                    x: 1000,              // start 100px off to the left
                    opacity: 0,
                    duration: 1,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: title,
                        start: 'top 80%',    // when the top of the title hits 80% down the viewport
                        toggleActions: 'play none none none'
                    }
                });
            });

            const blocks = context.querySelectorAll('.blockTextTwoColumns div, .blockText div h2, .blockText div p, .blockTeam, footer, .blockImage img');
            blocks.forEach(block => {
                gsap.from(block, {
                    opacity: 0,
                    duration: 2,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: block,
                        start: 'top 80%',  // when top of block hits 80% down viewport
                        toggleActions: 'play none none none'
                    },
                    onComplete: () => {
                        /*
                        gsap.from(context.querySelector('.blockImage'), {
                            opacity: 0,
                            duration: 1,
                            ease: 'power2.out'
                        });

                         */
                    }
                });
            });





            ScrollTrigger.refresh();
        }

    },

};

document.addEventListener('DOMContentLoaded', () => {
    Alpine.start(); // Start Alpine once DOM is ready
    app.init();     // Then run your init code
});

Alpine.start();


(() => {
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
        return;
    }
    const svgMarkup = `
    <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_246_426)">
        <path d="M32.5 63.5527C12.7847 63.5527 0 49.8232 0 32.083C0 14.3427 12.7847 0.613281 32.5 0.613281C52.2153 0.613281 65 14.3427 65 32.083C65 49.8232 52.2153 63.5527 32.5 63.5527ZM32.5 52.1115C45.0485 52.1115 50.1808 41.8143 50.1808 32.083C50.1808 22.3516 45.0485 12.0545 32.5 12.0545C19.9516 12.0545 14.8193 22.3516 14.8193 32.083C14.8193 41.8143 19.9516 52.1115 32.5 52.1115Z" fill="#FF694A"/>
        </g>
        <defs>
        <clipPath id="clip0_246_426">
        <rect width="65" height="64" fill="white"/>
        </clipPath>
        </defs>
    </svg>
  `;

    // --- 2) Helper to parse that markup into an <svg> element ---
    function makeSVGElement(markup) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(markup, "image/svg+xml");
        return doc.documentElement;  // the <svg> node
    }

    // --- 3) Create two SVG elements, one small & one large ---
    const svgSmall = makeSVGElement(svgMarkup);
    const svgLarge = makeSVGElement(svgMarkup);

    // --- 4) Apply shared styles and append to the body ---
    [svgSmall, svgLarge].forEach(el => {
        Object.assign(el.style, {
            position: 'fixed',
            pointerEvents: 'none',
            transform: 'translate(5%, 5%)',
            zIndex: '9999',
            willChange: 'left, top',
        });
        document.body.appendChild(el);
    });

    /*
    // --- 5) Resize them differently (override the viewBox) ---
    svgSmall.setAttribute('width', '34');
    svgSmall.setAttribute('height', '34');
    svgLarge.setAttribute('width', '34');
    svgLarge.setAttribute('height', '34');

     */


    /*
    let smallX = mouseX, smallY = mouseY;
    let largeX = mouseX, largeY = mouseY;
*/


    let smallX = -50,
        smallY = -50;
    // Put the large SVG just below/right of the viewport:
    let largeX = window.innerWidth + 50,
        largeY = window.innerHeight + 50;

    // Immediately stamp those coords into CSS so they stay put
    svgSmall.style.left = smallX + 'px';
    svgSmall.style.top = smallY + 'px';
    svgLarge.style.left = largeX + 'px';
    svgLarge.style.top = largeY + 'px';

    // Mouse target (not used until hasMoved)
    let mouseX = 0, mouseY = 0;
    let hasMoved = false;

    const offsetY = -4;

    // Lerp settings
    const minLerpSmall = 0.01;   // how much to move when far away
    const maxLerpSmall = 0.10;   // how much to move when very close
    const minLerpLarge = 0.08;
    const maxLerpLarge = 0.32;

    // Snap distance
    const snapDist = 1;

    const maxDist = Math.hypot(window.innerWidth, window.innerHeight);

    window.addEventListener('mousemove', e => {
        if (!hasMoved) hasMoved = true;

        mouseX = e.clientX;
        mouseY = e.clientY;
    });

    function tick() {
        if (hasMoved) {
            // SMALL DOT
            {
                const dx = mouseX - smallX;
                const dy = mouseY - smallY;
                const dist = Math.hypot(dx, dy);

                if (dist < snapDist) {
                    smallX = mouseX;
                    smallY = mouseY;
                } else {
                    // normalized closeness [0..1], 0=far, 1=very close
                    const t = 1 - Math.min(dist / maxDist, 1);
                    // lerp factor between min and max
                    const f = minLerpSmall + t * (maxLerpSmall - minLerpSmall);
                    smallX += dx * f;
                    smallY += dy * f;
                }

                svgSmall.style.left = smallX + 'px';
                svgSmall.style.top = smallY + offsetY + 'px';
            }

            // LARGE DOT
            {
                const dx = mouseX - largeX;
                const dy = mouseY - largeY;
                const dist = Math.hypot(dx, dy);

                if (dist < snapDist) {
                    largeX = mouseX;
                    largeY = mouseY;
                } else {
                    const t = 1 - Math.min(dist / maxDist, 1);
                    const f = minLerpLarge + t * (maxLerpLarge - minLerpLarge);
                    largeX += dx * f;
                    largeY += dy * f;
                }

                svgLarge.style.left = largeX + 'px';
                svgLarge.style.top = largeY + offsetY + 'px';
            }
        }
        requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
})();

window.teamOverlay = function (teamMembers) {
    return {
        rawHash: window.location.hash,
        teamMembers: teamMembers,
        get slug() {
            return this.rawHash.replace('#team-', '');
        },
        setHash(newHash) {
            this.rawHash = newHash;
        },
        init() {
            window.addEventListener('hashchange', () => {
                this.rawHash = window.location.hash;
            });

            document.querySelectorAll('a[href^="#team-"]').forEach(el => {
                el.addEventListener('click', e => {
                    const href = el.getAttribute('href');
                    if (href && href.startsWith('#team-')) {
                        this.setHash(href);
                    }
                });
            });
        }
    };
};